<template>
    <div class="ji_fen">
        <div class="top_bar">
            <div class="tab_box">
                <div class="tab_item" v-for="(item, index) in TabList" :key="index" :class="TabCur == index ? 'active_tab' : '' " @click="TabClick(item, index)" >
                    {{ item }}
                </div>
            </div>
            <!-- <div class="btn_box">
                <el-select v-model="value" placeholder="问责" style="width:165px;height:35px;margin: 0 10px;">
                    <el-option
                    
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
        </div>

        <div class="list_box" v-if="!noInfo">
            <el-timeline>
                <el-timeline-item  placement="top">
                    <el-card >
                        <div @click="getStepIndex( 0 )">
                            <h2 style="line-height:40px; color: #2767c4 ;">入党申请</h2>
                            <p>接收时间: {{ info[0].applyTime  }} </p>
                            <p>接收组织: {{ info[0].receiveDept  }} </p>
                        </div>
                    </el-card>
                </el-timeline-item>

                <el-timeline-item  placement="top">
                    <el-card >
                        <div @click="getStepIndex( 1 )">
                            <h2 style="line-height:40px; color: #2767c4 ;">{{ info[1].title }}</h2>
                            <p>一榜公示时间: {{ info[1].oneTime  }} </p>
                        </div>
                    </el-card>
                </el-timeline-item>

                <el-timeline-item  placement="top" >
                    <el-card >
                        <div @click="getStepIndex( 2 )">
                            <h2 style="line-height:40px; color: #2767c4 ;">{{ info[2].title }}</h2>
                            <p>发展对象时间: {{ info[2].developeTime }}</p>
                            <p>二榜公示时间: {{ info[2].twoTime  }} </p>
                            <h3 style="line-height: 40px">发展对象说明:</h3>
                            <p>{{ info[2].orgZhiWeiOption }}</p>
                        </div>
                    </el-card>
                </el-timeline-item>

                <el-timeline-item  placement="top">
                    <el-card >
                        <div @click="getStepIndex( 3 )">
                            <h2 style="line-height:40px; color: #2767c4 ;">{{ info[3].title }}</h2>
                            <p>入党志愿书填写时间: {{ info[3].rdzystime  }} </p>
                            <h3 style="line-height: 40px">接收预备党员预审的情况说明:</h3>
                            <p>{{ info[3].meetingPassResult }}</p>
                        </div>
                    </el-card>
                </el-timeline-item>

                <el-timeline-item  placement="top">
                    <el-card >
                        <div @click="getStepIndex( 4 )">
                            <h2 style="line-height:40px; color: #2767c4 ;">{{ info[4].title }}</h2>
                            <p>转正时间: {{ info[4].sqzzsjtime  }} </p>
                            <h3 style="line-height: 40px">转正审批意见:</h3>
                            <p>{{ info[4].becomeMemberSubjectOption }}</p>
                        </div>
                    </el-card>
                </el-timeline-item>


            </el-timeline>
        </div>

        <!-- 申报dialog -->
        <div class="dialog_model" v-if="ShenBaoDialogShow" @click.stop="cancelShenBao">
            <div class="dialog_box">
                <div class="dialog_title">
                    发展历程
                </div>
                <div class="form_box">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="180px" class="demo-ruleForm">
                        <el-form-item label="姓名"  v-if="formData.userName">
                            <el-input type="text" v-model="formData.userName" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="性别" v-if="formData.sex">
                            <el-input type="text" v-model="formData.sex" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="民族"  v-if="formData.minZu">
                            <el-input type="text" v-model="formData.minZu" disabled ></el-input>
                        </el-form-item>


                        <el-form-item label="学历"  v-if="formData.xueLi">
                            <el-input type="text" v-model="formData.xueLi" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="组织"  v-if="formData.deptName">
                            <el-input type="text" v-model="formData.deptName" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="生日"  v-if="formData.birthday">
                            <el-input type="text" v-model="formData.birthday" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="住址"  v-if="formData.homeAddress">
                            <el-input type="text" v-model="formData.homeAddress" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="身份证"  v-if="formData.idNumber">
                            <el-input type="text" v-model="formData.idNumber" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="手机号码"  v-if="formData.phone">
                            <el-input type="text" v-model="formData.phone" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="工作单位"  v-if="formData.workUnit">
                            <el-input type="text" v-model="formData.workUnit" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="入党申请书"  v-if="formData.rdsqs && formData.rdsqs.length">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.rdsqs" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>


                        <!-- 1 -->
                        <el-form-item label="个人基本情况"  v-if="formData.materail && formData.materail">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.materail" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="推优时间"  v-if="formData.tjtime">
                            <el-input type="text" v-model="formData.tjtime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="一榜公示情况登记表"  v-if="formData.onephotos && formData.onephotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.onephotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="一榜公示时间"  v-if="formData.onetime">
                            <el-input type="text" v-model="formData.onetime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党小组意见时间"  v-if="formData.dxztime">
                            <el-input type="text" v-model="formData.dxztime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党小组审批时间"  v-if="formData.dxzsptime">
                            <el-input type="text" v-model="formData.dxzsptime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党支部意见时间"  v-if="formData.applicationTime">
                            <el-input type="text" v-model="formData.applicationTime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="指定培养人"  v-if="formData.appointCultivatePeople">
                            <el-input type="text" v-model="formData.appointCultivatePeople" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="组织谈话时间"  v-if="formData.talkTime">
                            <el-input type="text" v-model="formData.talkTime" disabled ></el-input>
                        </el-form-item>

                         <el-form-item label="谈话记录"  v-if="formData.talkRecord">
                            <el-input type="text" v-model="formData.talkRecord" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党总支部意见时间"  v-if="formData.zzyjtime">
                            <el-input type="text" v-model="formData.zzyjtime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党总支部审批时间"  v-if="formData.zzsp">
                            <el-input type="text" v-model="formData.zzsp" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党委备案时间"  v-if="formData.dwba">
                            <el-input type="text" v-model="formData.dwba" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="积分分子情况说明"  v-if="formData.onephotos && formData.onephotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.onephotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="思想汇报"  v-if="formData.sxhbphotos && formData.sxhbphotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.sxhbphotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>
                        
                        <el-form-item label="培养教育和考察情况" v-if="formData.organizingTeaching">
                            <el-table
                            :data="formData.organizingTeaching"
                            
                            stripe
                            border
                            style="width: 100%">
                                <el-table-column
                                    prop="title"
                                    label="教育主题"
                                    align="center"
                                    >
                                </el-table-column>
                                <el-table-column
                                    prop="zhuJiangRen"
                                    label="主讲人"
                                    align="center"
                                    >
                                </el-table-column>
                                <el-table-column
                                    prop="jiaoYuType"
                                    align="center"
                                    label="教育类别">
                                </el-table-column>
                                <el-table-column
                                    prop="address"
                                    align="center"
                                    label="教育地址">
                                </el-table-column>
                                <el-table-column
                                    prop="jiaoYuTime"
                                    align="center"
                                    label="时间">
                                </el-table-column>
                            </el-table>
                        </el-form-item>

                        <!-- 2 -->

                        <el-form-item label="二榜公示情况登记表"  v-if="formData.twophotos && formData.twophotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.twophotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="二榜公示时间"  v-if="formData.twoTime">
                            <el-input type="text" v-model="formData.twoTime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党内外群众意见"  v-if="formData.publicOption">
                            <el-input type="text" v-model="formData.publicOption" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党小组意见"  v-if="formData.orgOption">
                            <el-input type="text" v-model="formData.orgOption" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党小组意见时间"  v-if="formData.discussDate">
                            <el-input type="text" v-model="formData.discussDate" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党支部意见时间"  v-if="formData.orgtime">
                            <el-input type="text" v-model="formData.orgtime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党支部意见"  v-if="formData.orgZhiWeiOption">
                            <el-input type="text" v-model="formData.orgZhiWeiOption" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党总支部意见时间"  v-if="formData.zorgtime">
                            <el-input type="text" v-model="formData.zorgtime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党委备案时间"  v-if="formData.dgwbatime">
                            <el-input type="text" v-model="formData.dgwbatime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="列为发展对象时间"  v-if="formData.developeTime">
                            <el-input type="text" v-model="formData.developeTime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="发展对象党支部书记"  v-if="formData.isDevUserId">
                            <el-input type="text" v-model="formData.isDevUserId" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="第一联系人"  v-if="formData.linkFirstPeople">
                            <el-input type="text" v-model="formData.linkFirstPeople" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="第二联系人"  v-if="formData.linkSecondPeople">
                            <el-input type="text" v-model="formData.linkSecondPeople" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="培养联系人意见时间"  v-if="formData.pxryjtime">
                            <el-input type="text" v-model="formData.pxryjtime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="发展对象政审时间"  v-if="formData.devzstime">
                            <el-input type="text" v-model="formData.devzstime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="发展对象政审结果"  v-if="formData.developeResult">
                            <el-input type="text" v-model="formData.developeResult" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="集中培训时间"  v-if="formData.collectTranDate">
                            <el-input type="text" v-model="formData.collectTranDate" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="集中培训结果"  v-if="formData.collectResult">
                            <el-input type="text" v-model="formData.collectResult" disabled ></el-input>
                        </el-form-item>

                         <el-form-item label="发展对象培训时间"  v-if="formData.devpxtime">
                            <el-input type="text" v-model="formData.devpxtime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="发展对象情况说明"  v-if="formData.devqksmphotos && formData.devqksmphotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.devqksmphotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="三榜公示情况登记表"  v-if="formData.threephotos && formData.threephotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.threephotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="三榜公示时间"  v-if="formData.threetime">
                            <el-input type="text" v-model="formData.threetime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党支部预审时间"  v-if="formData.dzbystime">
                            <el-input type="text" v-model="formData.dzbystime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党总支部审查时间"  v-if="formData.orgsctime">
                            <el-input type="text" v-model="formData.orgsctime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党委预审意见时间"  v-if="formData.adminshtime">
                            <el-input type="text" v-model="formData.adminshtime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="接收预备党员预审说明"  v-if="formData.jsdyys && formData.jsdyys">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.jsdyys" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>


                        <el-form-item label="相关资料"  v-if="formData.xgcl && formData.xgcl">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.xgcl" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <!-- 3 -->

                        <el-form-item label="入党志愿书填写时间"  v-if="formData.rdzystime">
                            <el-input type="text" v-model="formData.rdzystime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="预审时间"  v-if="formData.readyTime">
                            <el-input type="text" v-model="formData.readyTime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="预审结果"  v-if="formData.readyResult">
                            <el-input type="text" v-model="formData.readyResult" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="大会通过日期"  v-if="formData.meetingPassTime">
                            <el-input type="text" v-model="formData.meetingPassTime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="大会通过结果"  v-if="formData.meetingPassResult">
                            <el-input type="text" v-model="formData.meetingPassResult" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="组织谈话时间"  v-if="formData.orgTakeOverDate">
                            <el-input type="text" v-model="formData.orgTakeOverDate" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="组织谈话人"  v-if="formData.orgTakeOverUserId">
                            <el-input type="text" v-model="formData.orgTakeOverUserId" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="第一谈话人"  v-if="formData.firstIntroductPeople">
                            <el-input type="text" v-model="formData.firstIntroductPeople" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="第二谈话人"  v-if="formData.secondIntroductPeople">
                            <el-input type="text" v-model="formData.secondIntroductPeople" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="第一入党介绍人意见时间"  v-if="formData.onepersontime">
                            <el-input type="text" v-model="formData.onepersontime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="第二入党介绍人意见时间"  v-if="formData.twopersontime">
                            <el-input type="text" v-model="formData.twopersontime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党支部接收决议时间"  v-if="formData.dzbjysj">
                            <el-input type="text" v-model="formData.dzbjysj" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党总支部审批时间"  v-if="formData.orgshsj">
                            <el-input type="text" v-model="formData.orgshsj" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="专人谈话时间"  v-if="formData.sjdzzthtime">
                            <el-input type="text" v-model="formData.sjdzzthtime" disabled ></el-input>
                        </el-form-item>
                        
                        <el-form-item label="基层党委审批时间"  v-if="formData.jcdzztime">
                            <el-input type="text" v-model="formData.jcdzztime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="接收愚笨党员情况"  v-if="formData.readyqk && formData.readyqk">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.readyqk" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="培养教育考察情况"  v-if="formData.resdfsdf && formData.resdfsdf">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.resdfsdf" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="相关资料"  v-if="formData.xgcl2 && formData.xgcl2">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.xgcl2" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        


                        <!-- 4 -->

                        <el-form-item label="转正申请书"  v-if="formData.zzsqsphotos && formData.zzsqsphotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.zzsqsphotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="申请转正时间"  v-if="formData.sqzzsjtime">
                            <el-input type="text" v-model="formData.sqzzsjtime" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="预备党员转正决议时间"  v-if="formData.zzdfhdsa">
                            <el-input type="text" v-model="formData.zzdfhdsa" disabled ></el-input>
                        </el-form-item>

                        <!-- <el-form-item label="总支部审批时间"  v-if="formData.zzscsptime">
                            <el-input type="text" v-model="formData.zzscsptime" disabled ></el-input>
                        </el-form-item> -->

                        <el-form-item label="总支部审查时间"  v-if="formData.isy2time">
                            <el-input type="text" v-model="formData.isy2time" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="基层党委审批时间"  v-if="formData.isy3time">
                            <el-input type="text" v-model="formData.isy3time" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="专为正式党员的情况"  v-if="formData.zzdysqzsphotos && formData.zzdysqzsphotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.zzdysqzsphotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="是否延长预备期"  v-if="formData.isy">
                            <el-input type="text" v-model="formData.isy" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="转正日期"  v-if="formData.becomeMemberDate">
                            <el-input type="text" v-model="formData.becomeMemberDate" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="转正党小组讨论日期"  v-if="formData.becomMemberDiscussDate">
                            <el-input type="text" v-model="formData.becomMemberDiscussDate" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党员转正支部大会意见"  v-if="formData.becomeMemberOrgMeetingOption">
                            <el-input type="text" v-model="formData.becomeMemberOrgMeetingOption" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党员转正党小组意见"  v-if="formData.becomeMemberGroupOption">
                            <el-input type="text" v-model="formData.becomeMemberGroupOption" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党内外意见"  v-if="formData.becomMemberPublicOption">
                            <el-input type="text" v-model="formData.becomMemberPublicOption" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="委员会审查情况"  v-if="formData.committeeOption">
                            <el-input type="text" v-model="formData.committeeOption" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="大会讨论结果"  v-if="formData.meetingDicusssResult">
                            <el-input type="text" v-model="formData.meetingDicusssResult" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="党支部书记"  v-if="formData.partyBranchSecretar">
                            <el-input type="text" v-model="formData.partyBranchSecretar" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="审批组织"  v-if="formData.ext02">
                            <el-input type="text" v-model="formData.ext02" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="转正审批日期"  v-if="formData.becomeMemberSubjectDate">
                            <el-input type="text" v-model="formData.becomeMemberSubjectDate" disabled ></el-input>
                        </el-form-item>

                        <el-form-item label="转正审批意见"  v-if="formData.becomeMemberSubjectOption">
                            <el-input type="text" v-model="formData.becomeMemberSubjectOption" disabled ></el-input>
                        </el-form-item>

                        <!-- <el-form-item label="延期党员决议转正时间"  v-if="formData.isy1time">
                            <el-input type="text" v-model="formData.isy1time" disabled ></el-input>
                        </el-form-item> -->

                        <el-form-item label="相关资料"  v-if="formData.sgcl3 && formData.sgcl3">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.sgcl3" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="延长预备期情况"  v-if="formData.isyphotos && formData.isyphotos">
                            <div class="img_content">
                                <div class="img_box" v-for="(item, index) in formData.isyphotos" :key="index">
                                    <img :src="item" v-if="item.indexOf('http') != -1" alt="">
                                    <img :src="$ImgUrl + item" v-if="item.indexOf('http') == -1" alt="">
                                </div>
                            </div>
                        </el-form-item>

                        <!-- 5 -->

                        
                        <el-form-item>
                            <el-button class="sub_btn" @click="cancelShenBao">返回</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
            <no-more v-if="noInfo"></no-more>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                TabList: ["发展历程"],
                TabCur: 0,
                list: [
                    { tag: "学习积分", title: "日常政治表现良好。", type: "1", num: "+5" },
                    { tag: "学习积分", title: "日常政治表现良好。", type: "2", num: "-5" },
                    { tag: "学习积分", title: "日常政治表现良好。", type: "3", num: "+5" },
                    { tag: "学习积分", title: "日常政治表现良好。", type: "4", num: "-5" },
                    { tag: "学习积分", title: "日常政治表现良好。", type: "5", num: "+5" },
                ],

                ShenBaoDialogShow: false,
                formData: {

                },
                stepIndex: 0,
                info: {},
                base_id: "",
                noInfo: false,
            }
        },
        computed: {
            ...mapGetters(['token']),
            reqUrl () {
                let { stepIndex } = this 
                return `/lencon/pc/person/dev_member_detail_${ stepIndex }`
            }
        },
        mounted () {
            this.getInfo();
        },
        methods: {
            // 点击CARD获取索引
            async getStepIndex( index ) {
                let { base_id , token } = this 
                this.formData = {}
                let reqUrl = `/lencon/pc/person/dev_member_detail_${ index }`
                this.stepIndex = index
                let res = await this.$axios.post( reqUrl, { token, base_id } )
                if ( res.data.code == 1 ) {
                    this.formData = res.data.obj
                    this.ShenBaoDialogShow = true 
                } else {
                    
                }

            },
            // 点击tab
            TabClick(item, index) {
                this.TabCur = index
            },
            // 点击积分申报
            ShenBao () {
                this.ShenBaoDialogShow = true
            },
            // 取消申报
            cancelShenBao () {
                this.ShenBaoDialogShow = false
            },
            // 获取党员发展数据
            async getInfo () {
                let { token } = this 
                let res = await this.$axios.post("/lencon/pc/person/development_history", { token  })
                if ( res.data.code == 1 ) {
                    this.info = res.data.res
                    this.base_id = res.data.base_id
                    this.noInfo = false
                } else {
                    this.noInfo = true
                }
            },
        },
    }
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2767c4 ;
    color: #fff;
}
.el-card {
    cursor: pointer;
}
</style>


<style lang="scss" scoped>
.ji_fen {
    width: 980px;
    padding: 20px;
    box-sizing: border-box;
    .top_bar {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        border-bottom:1px solid #eeeeee;
        .tab_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            .tab_item {
                width: 120px;
                text-align: center;
                padding-bottom: 10px;
                cursor: pointer;
            }
            .active_tab {
                color: #2767c4 ;
                border-bottom: 2px solid #2767c4 ;
            }
        }

    }
    .list_box {
        width: 100%;
        margin-top: 30px;
        
    }

    .dialog_model {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.3);
        .dialog_box {
            width: 820px;
            height: 735px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -410px;
            margin-top: -377px;
            background-color: #fff;
            border-radius: 5px;
            overflow-y: scroll;
            padding: 20px;
            .dialog_title {
                font-size: 24px;
                font-weight: bold;
                padding-bottom: 20px;
                border-bottom: 2px solid #2767c4 ;
                color: #2767c4 ;
            }
            .form_box {
                padding: 20px 0;
                .sub_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #2767c4 ;
                }
                .cel_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #b3b3b3;
                }
            }


            .img_content {
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .img_box {
                    width: 100px;
                    height: 100px;
                    margin: 10px;
                    img {
                        width: 100px;
                        height: 100px;
                    }
                }
            }
        }
    }
}
</style>